import { render, staticRenderFns } from "./subfolder-add.vue?vue&type=template&id=3f3ec8b7"
import script from "./subfolder-add.vue?vue&type=script&lang=js"
export * from "./subfolder-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports